module.exports = __webpack_public_path__ + "static/media/full-bright--logo.538e95e0.png";